module.exports = __webpack_public_path__ + "img/P.059e0f83.webp";